import { SelectedPayableTypeState } from "reducers/selectedPayableTypeReducer";

export const getSelectedPayableType = (state: any) =>
  (state.selectedPayableType as SelectedPayableTypeState).selectedPayableType;
